var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", { staticClass: "opportunity-list-item" }, [
    _c("td", [_vm._v(_vm._s(_vm._f("nullable")(_vm.region.name)))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm._f("nullable")(_vm.adminEmail.toString())))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm._f("nullable")(_vm.region.from_email)))]),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "edit-button",
          on: {
            click: function ($event) {
              return _vm.$emit("edit", _vm.region.id)
            },
          },
        },
        [_c("i", { staticClass: "fa fa-fw fa-pencil-square-o" })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }